import styled from "styled-components";

import { Flex } from "@olist/design-system";

export const Wrapper = styled(Flex)`
  > svg {
    max-width: 609px;
    width: 100%;

    @media (min-width: 1280px) {
      min-width: 609px;
    }
  }
`;
